/**
 * 파라미터가 배열인지 여부를 검사합니다.
 * @param v
 * @returns {boolean}
 */
export default (v) => Array.isArray(v);
